import request from '../utils/request'
import qs from 'qs'
import { commonConfig } from '../utils/config'
const { apiUrl, apiHetaoDomain } = commonConfig

// 获取推广位列表
export async function getPromotionList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/position/list?${qs.stringify(params)}`)
}

// 三方店铺 达人管理
export async function getThirdPartyPromotionList (params) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/position/list`, {
    type: 'POST',
    params
  })
}

export async function addProduct (params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/position`, params)
}

export async function editProduct (params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/position`, params)
}

export async function getChannelList (teamCode) {
  return request(`${apiHetaoDomain}/ug-agent-back/v1/token/agent/channel/list?teamCode=${teamCode}`)
}

export async function updateChannel (params) {
  return request(`${apiUrl}/ug-agent-back/v1/token/agent/channel/updateChannel`, params)
}
